import React from 'react';
import qr from "../../Imagenes/beti_ren_qr.png";

function Instagram() {
  const handleUploadClick = () => {
    window.open('https://drive.google.com/drive/folders/1pPKSezEr5cQfzw9JNehyN3q7REUSD3Xl?usp=drive_link', '_blank'); // Reemplaza con el enlace de tu carpeta compartida
  };

  return (
    <div className="bg-white p-8 rounded-lg shadow-md text-center">
      <h2 className="font-great-vibes font-bold text-3xl mb-4 text-verde1">
        Estamos felices de compartir este día con ustedes
      </h2>
      <p className="text-oliva mb-6 font-semibold font-Libre-Baskerville">
        ¡Sube y comparte tus fotos y videos de este día tan especial con el #Beti&RenBoda!
      </p>
      <div className="flex justify-center mb-6">
        {/* Enlace que envuelve la imagen */}
        <a href="https://www.instagram.com/beti_ren/" target="_blank" rel="noopener noreferrer">
          <img 
            src={qr} 
            alt="Instagram QR" 
            className="rounded-md cursor-pointer w-48 h-48"  // Ajusta el tamaño aquí
          />
        </a>
      </div>

      {/* Botón para subir fotos y videos */}
      <button
        onClick={handleUploadClick}
        className="bg-verde2 text-white font-bold py-2 px-6 rounded-md hover:bg-verde3 transition-colors"
      >
        Subir Foto/Video
      </button>
    </div>
  );
}

export default Instagram;


